import { render, staticRenderFns } from "./RendersLibrary.vue?vue&type=template&id=b187c110&scoped=true&"
import script from "./RendersLibrary.vue?vue&type=script&lang=js&"
export * from "./RendersLibrary.vue?vue&type=script&lang=js&"
import style0 from "./RendersLibrary.vue?vue&type=style&index=0&id=b187c110&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b187c110",
  null
  
)

export default component.exports